var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"AProductionBomTree"},[_c('ATree',{attrs:{"value-field-name":"id","text-field-name":"name","data":_vm.nodes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }